/**
 * Chaves de `localStorage` compartilhadas entre módulos.
 *
 * <p><b>Por que existe:</b> a chave do último reload estava escrita como string
 * literal em três arquivos — quem escreve (`avplay/ramReload`) e dois que leem
 * (`remote-ops/RemoteOpsService`, `sync/SyncService`). Versionar a chave em um
 * lugar só faria os outros dois lerem `null` <b>sem erro nenhum</b>: o painel de
 * saúde simplesmente mostraria "nunca recarregou" para sempre.</p>
 *
 * <p>🔴 <b>Este módulo não importa nada, e não deve passar a importar.</b> Ele é
 * consumido pelo `SyncService`, e qualquer dependência aqui entra na cadeia dele
 * — o mesmo motivo que mantém `sseTelemetry` e `mediaCacheStats` sem imports.
 * Constante é dado, não comportamento; se algo aqui precisar de lógica, o lugar
 * é outro.</p>
 */

/**
 * Instante (epoch ms) do último reload periódico que o player registrou.
 *
 * Escrita por `avplay/ramReload`; lida pelo `health:report` e pela série de saúde.
 * Ausente = o player ainda não recarregou nesta instalação.
 */
export const LAST_RELOAD_AT_KEY = 'efflux_avplay_last_reload_at_v1';
